import { Injectable, NgModule } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
 HttpEvent,
 HttpInterceptor,
 HttpHandler,
 HttpRequest,
 HttpErrorResponse,
 HttpHeaders
} from '@angular/common/http';

import { throwError } from 'rxjs';
import { map, catchError  } from 'rxjs/operators';

import { SharedDataService } from '../../services/shared-data.service'
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '../../../environments/environment'
import { Router } from '@angular/router';
import { Url } from 'url';


function handleCompanyIdOnUrlRequest( url: string, comapnyId: string) {
  return environment.apiUrl + url.replace('$companyId', comapnyId)
}

function validateUrl(requestUrl: string, disabledUrl: Array<any> ) {
  let shoudUse = true;
  disabledUrl.map(url => {
    if (requestUrl.match(url)) {
      shoudUse = false;
    }
  })
  return shoudUse;
}

function shouldUseMainAPI(url: string) {
  return !url.match('third-party-api')
}

@Injectable()
export class APIInterceptor implements HttpInterceptor {
  disableUrl = [
    /login/gi,
    /chpwd/gi,
    /scroller/gi,
    /resBancos/gi
  ]

  constructor(private sharedService: SharedDataService, private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let apiReq: HttpRequest<any>;
    let newApiUrl: string;

    if ( shouldUseMainAPI(req.url) ) {
      const shoudUseTokenId = validateUrl(req.url, this.disableUrl)
      newApiUrl = handleCompanyIdOnUrlRequest(req.url, '')
      if (shoudUseTokenId) {
        apiReq = req.clone({ url: `${newApiUrl}?tokenId=${this.sharedService.getTokenId()}` });
      } else {
        apiReq = req.clone({ url: `${newApiUrl}`});
      }
      return next.handle(apiReq)
      .pipe(
        map((event: HttpEvent<any>) => {
            return event;
        }),
        catchError((error: HttpErrorResponse) => {
            console.log("ERROR HTTP", error)
            if (this.router.url === '/') {
              setTimeout(() => {
                window.location.reload()
              }, 500);
            }
            return throwError(error);
        }));
    } else {
      apiReq = req.clone({url: req.url.replace('$third-party-api/', '')})
      return next.handle(apiReq)
    }
  }
}

@Injectable()

export class HttpsRequestInterceptor implements HttpInterceptor {
  disabledUrls = [
    /company/gi,
    /login/gi,
    /chpwd/gi,
    /sintegraws/gi,
    /clientes/gi,
    /syjzv1cowf/gi,
    /1g6qkfti9g/gi,
    /cijyqfteu6/gi,
    /relBancos/gi,
    /valcnpj/gi,
    /security\?/gi,
    /approvals\?/gi,
    /approvals\/list\?/gi,
    /ipdvgvc/gi,
  ]

  constructor(private sharedService: SharedDataService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldUseHeaders = validateUrl(req.url, this.disabledUrls);
    if (req.headers['lazyUpdate']) {
      const dupReq = req.clone({
        headers: new HttpHeaders({
          'Accept-Language': 'pt-BR',
          'tenantId': req.headers['lazyUpdate'][0]['value']
        })
      });
      return next.handle(dupReq);
    } else if (shouldUseHeaders) {
      const dupReq = req.clone({
        headers: new HttpHeaders({
          'Accept-Language': 'pt-BR',
          'tenantId': this.sharedService.getTenantId()
        })
      });
      return next.handle(dupReq);
    } else {
      const dupReq = req.clone({
        headers: new HttpHeaders({
          'Accept-Language': 'pt-BR'
        })
      });
      return next.handle(dupReq);
    }
  }
}

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: APIInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpsRequestInterceptor,
      multi: true,
    },
  ],
})


export class Interceptor {}
